import type { FontSpec } from 'chart.js';

export const getChartDefaults = (): Partial<FontSpec> => {
  return { size: 14, family: 'Roboto, sans-serif' };
};
